import { isApiError } from '@/api/errors';
import { CopyButton } from '@/components/ui/CopyButton';
import {
  errorMessage,
  errorName,
  errorStack,
  formatErrorDetails,
} from '@/utils/errors/errorDetailsText';

/** Diagnostics disclosure for error screens — copy target for support tickets. */
export const ErrorTechnicalDetails = ({
  error,
  componentStack,
  className,
}: {
  error: unknown;
  componentStack?: string | null;
  className?: string;
}) => {
  const stack = errorStack(error);
  const api = isApiError(error) ? error : null;

  return (
    <details className={className}>
      <summary className="cursor-pointer select-none text-sm text-muted-foreground hover:text-foreground">
        Technical details
      </summary>
      <div className="mt-2 flex flex-col gap-2 rounded-md border border-border bg-muted/40 p-3 text-left">
        <div className="flex items-start justify-between gap-3">
          <p className="min-w-0 break-words font-mono text-xs text-foreground">
            {errorName(error)}: {errorMessage(error)}
          </p>
          <CopyButton
            value={() => formatErrorDetails(error, componentStack, window.location.href)}
            className="shrink-0"
          />
        </div>
        {api && (
          <p className="font-mono text-xs text-muted-foreground">
            {api.code} · {api.status}
            {api.traceId ? ` · trace ${api.traceId}` : ''}
          </p>
        )}
        {stack && (
          <pre className="max-h-48 overflow-auto rounded bg-background p-2 text-[11px] leading-snug text-muted-foreground">
            {stack}
          </pre>
        )}
        {componentStack && (
          <div>
            <p className="mb-1 text-xs font-medium text-muted-foreground">Component stack</p>
            <pre className="max-h-48 overflow-auto rounded bg-background p-2 text-[11px] leading-snug text-muted-foreground">
              {componentStack.trim()}
            </pre>
          </div>
        )}
      </div>
    </details>
  );
};
